/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ round: NonNullable<unknown> }} Sanction_Round_LabelInputs */



/**
* | output |
* | --- |
* | "Round {round}" |
*
* @param {Sanction_Round_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_round_label = /** @type {((inputs: Sanction_Round_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Round_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ronde ${i?.round}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ronda ${i?.round}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Rodada ${i?.round}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Round ${i?.round}`)
	return /** @type {LocalizedString} */ (`Round ${i?.round}`)
});